import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TimespanIntervalForm = _resolveComponent("TimespanIntervalForm")
  const _component_Column = _resolveComponent("Column")
  const _component_Button = _resolveComponent("Button")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, { class: "p-m-2" }, {
    content: _withCtx(() => [
      _createVNode(_component_TimespanIntervalForm, { propTimespan: _ctx.propTimespan }, null, 8, ["propTimespan"]),
      (_ctx.timespan && _ctx.timespan.definition?.length > 0)
        ? (_openBlock(), _createBlock(_component_DataTable, {
            key: 0,
            class: "p-datatable-sm kn-table p-m-2",
            value: _ctx.timespan.definition,
            responsiveLayout: "stack",
            breakpoint: "960px",
            scrollable: true,
            scrollHeight: "60vh"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
                return (_openBlock(), _createBlock(_component_Column, {
                  key: column.header,
                  field: column.field,
                  header: _ctx.$t(column.header),
                  style: column.style
                }, null, 8, ["field", "header", "style"]))
              }), 128)),
              _createVNode(_component_Column, {
                style: _ctx.timespanDescriptor.iconColumnStyle
              }, {
                body: _withCtx((slotProps) => [
                  _createVNode(_component_Button, {
                    icon: "pi pi-trash",
                    class: "p-button-link",
                    onClick: ($event: any) => (_ctx.deleteInterval(slotProps.data))
                  }, null, 8, ["onClick"])
                ]),
                _: 1
              }, 8, ["style"])
            ]),
            _: 1
          }, 8, ["value"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}